
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Social Media SEO : comment améliorer son référencement naturel",
    description:
      "Découvrez comment le social media SEO booste votre positionnement sur les moteurs de recherche, renforçant ainsi la visibilité et l’impact de votre marque.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
